module.exports = __webpack_public_path__ + "static/media/banner7.8f55e18c.jpg";